import React from 'react';
import PageHero from '../components/PageHero';
import PageBlocks, { usePageBlocks } from '../components/PageBlocks';
import PastPresidentsSection from '../components/sections/PastPresidentsSection';
import { useTranslation } from '../i18nContext';

export default function ExpresidentesPage() {
  const t = useTranslation();
  const locale = t.locale;
  const { blocks } = usePageBlocks('past-presidents');
  return (
    <>
      <PageHero
        label="CMIC"
        title={locale === 'es' ? 'Expresidentes' : 'Past Presidents'}
        subtitle={locale === 'es' ? 'Historia y legado del CMIC' : 'History and legacy of CMIC'}
      />
      {blocks.length > 0 ? <PageBlocks pageKey="past-presidents" /> : <PastPresidentsSection />}
    </>
  );
}
